import { createAsyncCategoryHandler } from "../category-dispatcher";
import { propertyTools } from "./property-tools";

/**
 * Category handler for micro-app operations.
 * All operations are asynchronous, sourced from property-tools async handlers.
 */
export const handleMicroappCategory = createAsyncCategoryHandler(
  {},
  {
    list_projects: propertyTools.async!.ui_logic_list_microapp_projects,
    list_screens: propertyTools.async!.ui_logic_list_microapp_project_screens,
    list_screen_inputs: propertyTools.async!.ui_logic_list_microapp_screen_inputs,
    set_project: propertyTools.async!.ui_logic_set_microapp_project,
    set_starting_screen: propertyTools.async!.ui_logic_set_microapp_starting_screen
  }
);
